import request from '@/api/request'

const getDefaultUserInfo = () => {
  try {
    const savedInfo = localStorage.getItem('userInfo')
    if (savedInfo) {
      const userInfo = JSON.parse(savedInfo)
      return {
        name: userInfo.UserName || userInfo.userName || userInfo.realName || '未知用户',
        roleId: userInfo.RoleID || userInfo.roleId,
        id: userInfo.UserID || userInfo.userId,
        ...userInfo
      }
    }
  } catch (e) {
    console.error('解析用户信息失败:', e)
  }
  return {
    name: '未知用户',
    roleId: '',
    id: ''
  }
}

const state = {
  token: localStorage.getItem('token') || '',
  userInfo: getDefaultUserInfo(),
  permissions: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  CLEAR_USER_STATE: (state) => {
    state.token = ''
    state.userInfo = {}
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  }
}

const actions = {
  // 登录
  async login({ commit, dispatch }, loginData) {
    try {
      const response = await request({
        url: '/api/v1/login',
        method: 'POST',
        data: loginData
      })

      console.log('登录响应:', response)  // 查看登录返回的数据结构

      if (response.status === 1) {
        const { token, user } = response.data
        
        // 构造标准的用户信息对象
        const userInfo = {
          name: user.UserName || user.userName || user.realName,  // 尝试不同的属性名
          roleId: user.RoleID || user.roleId,
          id: user.UserID || user.userId,
          ...user  // 保留原始数据
        }

        // 保存 token 和用户信息
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', userInfo)

        console.log('保存的用户信息:', userInfo)

        // 登录成功后获取权限
        await dispatch('getPermissions')
        return true
      }
      throw new Error(response.msg || '登录失败')
    } catch (error) {
      console.error('登录失败:', error)
      throw error
    }
  },

  // 获取用户权限
  async getPermissions({ commit, state }) {
    try {
      const response = await request({
        url: '/api/v1/role/permissions/list',
        method: 'POST',
        data: {
          roleId: state.userInfo.roleId
        }
      })

      if (response.status === 1 && response.data && response.data.permissions) {
        commit('SET_PERMISSIONS', response.data.permissions)
      }
    } catch (error) {
      console.error('获取权限失败:', error)
    }
  },

  // 登出
  logout({ commit }) {
    commit('CLEAR_USER_STATE')
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 